<template>
  <div class="chart-container">
    <div class="chart-main-container">
      <chart ref="chart" chartType="line" chartId="WeeklyChart" :width="size === 'mini' ? 300 : 836"
             :height="size === 'mini' ? 180 : 400"></chart>
    </div>
  </div>
</template>

<script lang="js">
import { GraphLineColorSet } from '../../defines/chart-color'
import ChartCmp from './base.vue'

export default {
  name: 'WeeklyChartCmp',
  components: {
    'chart': ChartCmp
  },
  props: {
    weeklyComparison: {type: Object, default: () => {}},
    yName: '',
    categoryId: '',
    size: '',
    initialColumnIndex: {type: Number, default: 0}
  },
  data () {
    return {
      selectedColumnIndex: -1,
      selectedWeeklyResult: null,
      colorSet: GraphLineColorSet,
      weekMap: {
        Monday: '月曜日',
        Tuesday: '火曜日',
        Wednesday: '水曜日',
        Thursday: '木曜日',
        Friday: '金曜日',
        Saturday: '土曜日',
        Sunday: '日曜日'
      }
    }
  },
  created () {
    this.selectedColumnIndex = this.initialColumnIndex
    this.$nextTick(() => {
      this.$forceUpdate()
    })
  },
  watch: {
    selectedColumnIndex (newIndex) {
      if (newIndex < 0) return
      this.selectedWeeklyResult = this.weeklyComparison.results[newIndex]
    },
    selectedWeeklyResult (weeklyResult) {
      if (!weeklyResult) return

      const ds = weeklyResult.value.map(value => value.ds)
      const importance = weeklyResult.value.map(value => value.importance)
      const isMini = this.size === 'mini'
      const weekMap = this.weekMap

      let datasets = []
      datasets.push(
        Object.assign(
          {
            data: importance,
            type: 'line',
            yAxisID: 'importance',
            fill: false,
            lineTension: 0,
            pointRadius: isMini ? 0 : 3,
            pointBorderWidth: isMini ? 0 : 8
          },
          this.colorSet.red
        )
      )

      const chartData = {
        labels: ds,
        datasets: datasets
      }

      const options = {
        responsive: isMini,
        title: {
          display: false
        },
        legend: {
          display: false
        },
        scales: {
          yAxes: [
            {
              id: 'importance',
              position: 'left',
              type: 'linear',
              scaleLabel: {
                display: true,
                fontSize: 16
              },
              gridLines: {
                drawOnChartArea: false
              },
              ticks: {
                beginAtZero: false
              }
            }
          ],
          xAxes: [
            {
              scaleLabel: {
                display: true,
                fontSize: 16
              },
              ticks: {
                maxRotation: 90,
                callback: function (value, index, values) {
                  if (weekMap.hasOwnProperty(value)) {
                    return weekMap[value]
                  } else {
                    return value
                  }
                }
              }
            }
          ]
        }
      }

      this.$refs.chart.renderChart(chartData, options)
    }
  }
}

</script>

<style scoped>
  .chart-container {
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    justify-content: center;
  }

  .chart-main-container {
    display: flex;
    justify-content: center;
  }
</style>



// WEBPACK FOOTER //
// src/components/chart/weekly.vue